import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import TarjetaServicio from "./cardServicioAdmin";

function ListaServicios({ servicios = [], total, paginas = 1, pagina = 1, onCambiarPagina, onClickVer, cargando = false }) {
    const [lista, setLista] = useState(servicios);

    useEffect(() => { setLista(servicios); }, [servicios]);

    async function pausarServicio(s) {
        const confirm = await Swal.fire({
            icon: "warning",
            title: "¿Pausar este servicio?",
            text: "El servicio dejará de mostrarse en el marketplace hasta que se reanude.",
            showCancelButton: true,
            confirmButtonText: "Sí, pausar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "var(--azul-logo-fondo)",
        });
        if (!confirm.isConfirmed) return;
        try {
            const res = await axios.post("/pausar-servicio", {
                params: { idServicio: s.idServicio, idVendedor: s.idUsuario },
            });
            if (res.data?.modificado === false) {
                return Swal.fire({ icon: "error", title: "No se pudo pausar", text: res.data?.mensaje || "No se pudo pausar el servicio.", confirmButtonColor: "var(--azul-logo-fondo)" });
            }
            setLista(prev => prev.map(x => x.idServicio === s.idServicio ? { ...x, estado: "Pausado" } : x));
        } catch {
            Swal.fire({ icon: "error", title: "Error", text: "No se pudo pausar el servicio.", confirmButtonColor: "var(--azul-logo-fondo)" });
        }
    }

    if (cargando) return (
        <div className="text-center py-5">
            <span className="spinner-border text-primary" role="status" />
        </div>
    );

    if (lista.length === 0) return (
        <div className="border rounded-4 p-5 bg-light text-center">
            <i className="bi bi-briefcase fs-2 text-muted"></i>
            <p className="text-muted small mb-0 mt-2">No hay servicios en este estado.</p>
        </div>
    );

    const totalMostrar = total ?? lista.length;

    return (
        <>
            <p className="text-muted small mb-3">
                {totalMostrar.toLocaleString("es-CO")} servicio{totalMostrar !== 1 ? "s" : ""}
                {paginas > 1 && <span className="ms-2">· página {pagina} de {paginas}</span>}
            </p>

            <div className="d-flex flex-column gap-2 mb-4">
                {lista.map(s => (
                    <TarjetaServicio
                        key={s.idServicio}
                        servicio={s}
                        onClickVer={() => onClickVer?.(s)}
                        onPausar={s.estado === "Aprobado" ? () => pausarServicio(s) : undefined}
                    />
                ))}
            </div>

            {paginas > 1 && (
                <nav>
                    <ul className="pagination pagination-sm justify-content-center gap-1 flex-wrap">
                        <li className={`page-item ${pagina === 1 ? "disabled" : ""}`}>
                            <button className="page-link rounded-3 border-0 shadow-sm" onClick={() => onCambiarPagina?.(pagina - 1)}>
                                <i className="bi bi-chevron-left"></i>
                            </button>
                        </li>
                        {Array.from({ length: paginas }, (_, i) => i + 1)
                            .filter(p => p === 1 || p === paginas || Math.abs(p - pagina) <= 2)
                            .reduce((acc, p, idx, arr) => {
                                if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
                                acc.push(p);
                                return acc;
                            }, [])
                            .map((p, i) =>
                                p === "..." ? (
                                    <span key={`e-${i}`} className="text-muted px-1">…</span>
                                ) : (
                                    <button
                                        key={p}
                                        className={`btn btn-sm rounded-3 px-3 ${p === pagina ? "btn-dark" : "btn-outline-secondary"}`}
                                        onClick={() => onCambiarPagina?.(p)}
                                    >
                                        {p}
                                    </button>
                                )
                            )
                        }
                        <li className={`page-item ${pagina === paginas ? "disabled" : ""}`}>
                            <button className="page-link rounded-3 border-0 shadow-sm" onClick={() => onCambiarPagina?.(pagina + 1)}>
                                <i className="bi bi-chevron-right"></i>
                            </button>
                        </li>
                    </ul>
                </nav>
            )}
        </>
    );
}

export default ListaServicios;
